// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Air Burst",
  id: "air-burst",
  metadata: {
    aspect: SavedSpellAspect.Air,
    imports: ["air","self"],
    icon: {
      "backgroundColor": 993330,
      "layers": [
        {
          "iconKey": "air",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 15,
          "color": 16773119
        }
      ]
    },
  },
};

export default metadata;
